"use client";

import React, { useState, useRef, useEffect } from "react";
import "./navbar.scss";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { NavLinks } from "../../data/data";

import { ReactComponent as Logo } from "../../assets/svg/logo.svg";
import { ReactComponent as SideBtn } from "../../assets/svg/side-btn.svg";
import { ReactComponent as Menu } from "../../assets/svg/menu.svg";
import { ReactComponent as Close } from "../../assets/svg/close.svg";
import { ReactComponent as MobileLogo } from "../../assets/svg/mobile-logo.svg";
import { ReactComponent as ActiveLogo } from "../../assets/svg/active-logo.svg";

const Navbar = () => {
  const navMenu = useRef(null);
  const [showLinks, setShowLinks] = useState(false);
  const [toggleNavMenu, setToggleNavMenu] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);

  const location = useLocation();
  const pathName = location.pathname;

  useEffect(() => {
    showLinks
      ? navMenu.current.classList.add("show-menu")
      : navMenu.current.classList.remove("show-menu");
  }, [showLinks]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleToggleNavMenu = () => {
    setToggleNavMenu(!toggleNavMenu);
    setShowLinks(!showLinks);
  };

  const handleNavLinkClose = () => {
    setShowLinks(false);
    setToggleNavMenu(!toggleNavMenu);
  };
  const pathLogo = pathName === "/case-studies" || pathName === "/blogs";

  return (
    <header
      className={`nav ${
        pathName === "/case-studies" || pathName === "/blogs" ? "nav-black" : ""
      }`}
    >
      <nav className="nav__container container">
        <Link to="/" className="nav__logo">
          {pathLogo ? (
            isMobileView && toggleNavMenu ? (
              // On mobile and after toggleNavMenu for "/case-studies" or "/blogs"
              <MobileLogo className="nav__logo-img mobile-logo" />
            ) : (
              // On desktop or before toggleNavMenu for "/case-studies" or "/blogs"
              <MobileLogo className="nav__logo-img" />
            )
          ) : isMobileView ? (
            // On mobile for other pathnames
            toggleNavMenu ? (
              // After toggleNavMenu for other pathnames
              <MobileLogo className="nav__logo-img mobile-logo" />
            ) : (
              // Before toggleNavMenu for other pathnames
              <Logo className="nav__logo-img" />
            )
          ) : (
            // On desktop for other pathnames
            <Logo className="nav__logo-img" />
          )}
        </Link>

        <div className="nav__menu" ref={navMenu}>
          <ul className="nav__list">
            {NavLinks.map((link) => {
              const { id, title, url, target } = link;
              const isActive = pathName.startsWith(url);
              return (
                <li className="nav__item" key={id}>
                  <Link
                    to={url}
                    className={`nav__link ${isActive ? "active-navLink" : ""} ${
                      pathName === "/case-studies" || pathName === "/blogs"
                        ? "navLink-white"
                        : ""
                    }`}
                    onClick={handleNavLinkClose}
                    target={target}
                  >
                    {isActive && <ActiveLogo className="active-link-svg" />}
                    {title}
                  </Link>
                </li>
              );
            })}
          </ul>

          <div
            className="nav__service nav__service-mobile"
            onClick={handleNavLinkClose}
          >
            <Link to="/contact-us" className="contact__btn-wrapper">
              <button className="contact__btn">
                <span> Contact Us</span>
              </button>
              <SideBtn />
            </Link>
          </div>
        </div>

        <div
          className="nav__service nav__service-desktop"
          onClick={handleNavLinkClose}
        >
          <Link to="/contact-us" className="contact__btn-wrapper">
            <button className="contact__btn">
              <span> Contact Us</span>
            </button>
            <SideBtn />
          </Link>
        </div>

        <div className="nav__toggle" onClick={handleToggleNavMenu}>
          {toggleNavMenu ? (
            <button type="button" className="nav__toggle-btn close">
              <span>
                <Close />
                Close
              </span>
            </button>
          ) : (
            <button type="button" className="nav__toggle-btn menu">
              <span>
                <Menu />
                Menu
              </span>
            </button>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
